import englishCa from './enCa.json';
import englishUSA from './enUs.json';
import { format } from 'date-fns';
import { frCA } from 'date-fns/locale';
import frenchCAN from './frCa.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { isSiteCanadian } from 'src/utils/helpers';

const resourceContent = {
    'en-CA': {
        translation: englishCa,
    },
    'en-US': {
        translation: englishUSA,
    },
    'fr-CA': {
        translation: frenchCAN,
    },
};

i18n
    // passes i18n down to react-i18next
    .use(initReactI18next)
    .init({
        interpolation: {
            // React already does escaping
            format: (value, formatedDate, lng) => {
                if (value instanceof Date && lng === 'fr-CA') {
                    return format(value, formatedDate || 'dd MMM yyyy', {
                        locale: frCA,
                    });
                }
                if (value instanceof Date && lng !== 'fr-CA') {
                    return format(value, formatedDate || 'MMM dd, yyyy');
                }
                return value;
            },
            escapeValue: false,
        },
        // 'en' | 'es'
        lng: i18n.language || isSiteCanadian() ? 'en-CA' : 'en-US',
        fallbackLng: 'en-US',
        resources: resourceContent,
        keySeparator: '.',
    });

export default i18n;
